/**
 * Representative dev/mock listings with messy field names for normalizer QA (Milestone 2).
 * Import and pass through normalizeVehicleListings() — do not use raw in UI.
 */
export const DEV_SAMPLE_VEHICLE_LISTINGS_RAW = [
  {
    vehicleListingId: "dev-normal-001",
    slug: "toyota-corolla-2020-medellin",
    title: "Toyota Corolla 2020 XEI",
    make: "Toyota",
    model: "Corolla",
    year: 2020,
    priceCop: 58_000_000,
    mileageKm: 62_000,
    transmission: "automatic",
    fuelType: "gasoline",
    bodyType: "sedan",
    city: "Medellín",
    department: "Antioquia",
    dealerId: "dealer-001",
    dealerName: "Toyota del Sur",
    dealerVerified: true,
    dealerVerificationStatus: "verified",
    dealerWhatsapp: "+573001112233",
    images: ["/client-views/autoclaro/vehicle-placeholder.jpg"],
    status: "active",
    availabilityStatus: "available",
    fairPriceLabel: "fair_price",
    riskLevel: "low",
    lastConfirmedAt: new Date(Date.now() - 3 * 3_600_000).toISOString(),
  },
  {
    id: "dev-missing-price",
    slug: "sin-precio-demo",
    make: "Chevrolet",
    model: "Spark",
    year: 2018,
    mileageKm: 89000,
    city: "Bogotá",
    sellerName: "Autos Demo",
    status: "active",
    availabilityStatus: "pending_confirmation",
    riskLevel: "medium",
  },
  {
    vehicleListingId: "dev-missing-mileage",
    listPrice: 42000000,
    make: "Renault",
    model: "Logan",
    year: 2019,
    city: "Cali",
    dealer_name: "Renault Cali",
    status: "active",
    availabilityStatus: "available",
    fairPriceLabel: "not_enough_data",
    riskLevel: "unknown",
  },
  {
    id: "dev-missing-images",
    price_cop: 35000000,
    make: "Hyundai",
    model: "Accent",
    year: 2017,
    mileage_km: 120000,
    city: "Medellín",
    sourceName: "Hyundai Norte",
    status: "active",
    availabilityStatus: "available",
    riskLevel: "low",
  },
  {
    vehicleListingId: "dev-verified-dealer",
    priceCop: 95000000,
    make: "Mazda",
    model: "CX-5",
    year: 2021,
    mileageKm: 35000,
    city: "Medellín",
    dealerName: "Mazda Premium",
    dealerVerified: true,
    dealerVerificationStatus: "verified",
    primaryImageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
    status: "active",
    availabilityStatus: "available",
    fairPriceLabel: "fair_price",
    riskLevel: "low",
  },
  {
    id: "dev-unverified-dealer",
    currentPriceCop: 48000000,
    make: "Kia",
    model: "Rio",
    year: 2019,
    mileageKm: 71000,
    city: "Envigado",
    sellerName: "Kia Usados Envigado",
    dealerVerified: false,
    dealerVerificationStatus: "unverified",
    status: "active",
    availabilityStatus: "available",
    riskLevel: "medium",
  },
  {
    vehicleListingId: "dev-high-risk",
    priceCop: 28000000,
    make: "Chevrolet",
    model: "Aveo",
    year: 2014,
    mileageKm: 185000,
    city: "Medellín",
    dealerName: "Lote Económico",
    status: "active",
    availabilityStatus: "pending_confirmation",
    fairPriceLabel: "high_price",
    riskLevel: "high",
    hasIncompleteInfo: true,
    primaryImageUrl: "/client-views/autoclaro/vehicle-placeholder.jpg",
  },
  {
    id: "dev-sold-listing",
    priceCop: 67000000,
    make: "Nissan",
    model: "Kicks",
    year: 2020,
    mileageKm: 45000,
    city: "Medellín",
    dealerName: "Nissan Center",
    status: "sold",
    availabilityStatus: "sold",
    riskLevel: "low",
  },
  {
    vehicleListingId: "dev-stale-listing",
    priceCop: 72000000,
    make: "Ford",
    model: "Escape",
    year: 2018,
    mileageKm: 98000,
    city: "Medellín",
    dealerName: "Ford Usados",
    status: "active",
    availabilityStatus: "pending_confirmation",
    lastConfirmedAt: new Date(Date.now() - 20 * 24 * 3_600_000).toISOString(),
    riskLevel: "medium",
    fairPriceLabel: "slightly_high",
  },
  {
    id: "dev-no-dealer",
    priceCop: 39000000,
    make: "Suzuki",
    model: "Swift",
    year: 2016,
    mileageKm: 102000,
    city: "Bello",
    status: "active",
    availabilityStatus: "available",
    riskLevel: "unknown",
  },
];
